
import { Component, Emit, Vue } from 'nuxt-property-decorator'
import BaseIconButton from '../base/BaseIconButton.vue'

@Component({
  name: 'TheModal',
  components: {
    BaseIconButton,
  },
})
export default class TheModal extends Vue {
  @Emit('close-modal')
  private closeModal () : boolean {
    this.$store.commit('ModalContent/reset')
    return true
  }
}
